import React from "react";
import { ASSETS } from "../assetManifest";
import { CONSTANTS } from "../constants/gameConstants";

export function TroopSelector({
  draggingTroop,
  onTroopMouseDown,
  resources,
  paused,
  currentTroopCount,
  maxTroops,
  troopCosts,
  inTutorial,
  tutorialStep,
}: {
  draggingTroop: string | null,
  onTroopMouseDown: (e: React.MouseEvent, troopType: string) => void,
  resources: number,
  paused: boolean,
  currentTroopCount: number,
  maxTroops: number,
  troopCosts: { [key: string]: number },
  inTutorial: boolean,
  tutorialStep: number,
}) {
  const troopLimitReached = currentTroopCount >= maxTroops;

  return (
    <div
      className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-4 pointer-events-auto"
      style={{ flexWrap: "wrap" }}
    >
      {Object.entries(CONSTANTS.TROOPS).filter(([key, troop]) => troop.cost > 0).map(([key, troop]) => {
        const currentCost = troopCosts[key] || troop.cost;
        
        let isTutorialDisabled = false;
        if (inTutorial) {
            // During steps 1 and 3 of the tutorial, only 'melee' (warrior) is allowed.
            if ((tutorialStep === 1 || tutorialStep === 3) && key !== 'melee') {
                isTutorialDisabled = true;
            }
        }

        return (
          <button
            key={key}
            onMouseDown={(e) => onTroopMouseDown(e, key)}
            disabled={resources < currentCost || paused || troopLimitReached || isTutorialDisabled}
            className={`p-4 rounded-lg shadow-xl transition-all duration-200 border-4 ${(draggingTroop === key) ? 'border-yellow-400 scale-110' : 'border-gray-700'} bg-gray-800 hover:border-yellow-300 disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            <div className="flex flex-col items-center text-white" style={{ pointerEvents: 'none' }}>
              <img src={ASSETS.sprites[key].path} alt={key} className="w-16 h-16" />
              <span className="font-bold mt-2 capitalize">{troop.name || key}</span>
              <div className="flex items-center text-yellow-400">
                <img src={ASSETS.sprites.currency_coin.path} alt="cost" className="w-4 h-4 mr-1" />
                <span>{currentCost}</span>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
